import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/avatares/avatar.svg'


const _hoisted_1 = ["initial", "enter"]
const _hoisted_2 = {
  key: 0,
  id: "chat-record",
  class: "recorder-body absolute w-full z-20 flex justify-center items-center rounded-t-sm h-[90%] sm:h-[88%]"
}
const _hoisted_3 = {
  id: "chat-header",
  class: "p-4 w-full bg-white border-b rounded-t-sm relative flex flex-row items-center space-x-4"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "avatar"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Homero"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400" }, "Online")
], -1)
const _hoisted_6 = {
  id: "chat-messages",
  class: "chat-body bg-white p-8 overflow-auto transition-all"
}
const _hoisted_7 = {
  id: "chat-footer",
  class: "w-full bg-white flex flex-row space-x-3 p-5 absolute bottom-0 break-words"
}
const _hoisted_8 = { class: "fixed bottom-1 right-1 z-10 flex items-end flex-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LimitTimeModal = _resolveComponent("LimitTimeModal")!
  const _component_Recording = _resolveComponent("Recording")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Messages = _resolveComponent("Messages")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_SpeechBubble = _resolveComponent("SpeechBubble")!
  const _component_ModalPermissionBrowser = _resolveComponent("ModalPermissionBrowser")!
  const _component_Crawler = _resolveComponent("Crawler")!
  const _directive_motion = _resolveDirective("motion")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(_component_LimitTimeModal, {
      timeLimit: _ctx.currentMaterial?.expectedConclusionTime * 1000,
      nameStudent: _ctx.user?.firstName,
      onOnOpenChat: _ctx.openChatHomero,
      onOnNeedsToPause: _ctx.onNeedsToPause
    }, null, 8, ["timeLimit", "nameStudent", "onOnOpenChat", "onOnNeedsToPause"]),
    (_ctx.openChat)
      ? _withDirectives((_openBlock(), _createElementBlock("main", {
          key: 0,
          id: "chat",
          initial: _ctx.initialMotion,
          enter: _ctx.enterMotion,
          class: _normalizeClass(`chat-bot w-[85vw] h-[100vh] ${_ctx.hSize} z-50 lg:z-0 lg:static fixed bottom-0 rounded-t-sm transition-all bg-blue-400`)
        }, [
          (_ctx.recorded)
            ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                _createVNode(_component_Recording, {
                  onOnRecordStop: _cache[0] || (_cache[0] = ($event: any) => (_ctx.recordStop()))
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("section", _hoisted_3, [
            _createElementVNode("button", {
              class: "absolute top-4 right-4",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeChat()))
            }, [
              _createVNode(_component_v_icon, {
                name: "md-close",
                class: "text-primary-400"
              })
            ]),
            _hoisted_4,
            _hoisted_5
          ]),
          _createElementVNode("section", _hoisted_6, [
            _createVNode(_component_Messages, {
              onOnOpenCrawler: _ctx.openCrawler,
              messages: _ctx.messages,
              action: { isGpt: _ctx.isGpt },
              loaderMsg: _ctx.loaderMsg,
              autoPlay: _ctx.autoPlay
            }, null, 8, ["onOnOpenCrawler", "messages", "action", "loaderMsg", "autoPlay"])
          ]),
          _createElementVNode("section", _hoisted_7, [
            _createVNode(_component_Footer, {
              onOnRecordStop: _cache[2] || (_cache[2] = ($event: any) => (_ctx.recordStop())),
              onOnStartRecord: _cache[3] || (_cache[3] = ($event: any) => (_ctx.startStreaming())),
              onOnGetMessage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getMessageDiv())),
              textSize: _ctx.verifyTextSize(),
              recorded: _ctx.recorded
            }, null, 8, ["textSize", "recorded"])
          ])
        ], 10, _hoisted_1)), [
          [_directive_motion]
        ])
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.startMessage)
        ? (_openBlock(), _createBlock(_component_SpeechBubble, {
            key: 0,
            onOnCloseSpeechBubble: _ctx.closeSpeechBubble,
            onOnOpenChat: _ctx.openChatHomero,
            onOnHomeroRandomQuestion: _ctx.homeroRandomQuestion,
            startMessage: _ctx.startMessage,
            user: _ctx.user,
            msgType: _ctx.speechBubbleType
          }, null, 8, ["onOnCloseSpeechBubble", "onOnOpenChat", "onOnHomeroRandomQuestion", "startMessage", "user", "msgType"]))
        : _createCommentVNode("", true),
      (!_ctx.openChat)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openChatHomero())),
            onMouseenter: _cache[6] || (_cache[6] = ($event: any) => (_ctx.speechBubbleType === 'default' ? _ctx.openSpeechBubble() : '')),
            onMouseout: _cache[7] || (_cache[7] = ($event: any) => (_ctx.speechBubbleType === 'default' ? _ctx.closeSpeechBubble() : '')),
            class: _normalizeClass(`bg-cover w-[80px] h-[80px] xl:w-[100px] xl:h-[100px] bg-[url('@/assets/images/avatares/avatar-chatbot.svg')] hover:scale-95 transition-all ${
          _ctx.hasSpeech === true ? 'animate-ping' : ''
        }`)
          }, null, 34))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showModalPermissionBrowser)
      ? (_openBlock(), _createBlock(_component_ModalPermissionBrowser, {
          key: 1,
          showModalPermissionBrowser: _ctx.showModalPermissionBrowser,
          onOnCloseModalPermissionBrowser: _ctx.closeModalPermissionBrowser
        }, null, 8, ["showModalPermissionBrowser", "onOnCloseModalPermissionBrowser"]))
      : _createCommentVNode("", true),
    (_ctx.showModal)
      ? (_openBlock(), _createBlock(_component_Crawler, {
          key: 2,
          onOnClose: _ctx.onCloseCrawler,
          keyword: _ctx.keyword
        }, null, 8, ["onOnClose", "keyword"]))
      : _createCommentVNode("", true)
  ]))
}